import React from 'react';
import OptionTitle from '../../OptionElements/OptionTitle';
import OptionDescription from '../../OptionElements/OptionDescription';
import OptionFootnote from '../../OptionElements/OptionFootnote';

export default function OptionTypeText({options}) {
  return (
    <div className="app-option-list">
      {options.map((option, index) => {
        const {
          title,
          description,
          footnote,
          customClass = ''
        } = option;

        return (
          <div className={`app-option-item ${customClass}`} key={index}>
            <OptionTitle title={title} />
            <OptionDescription description={description} />
            <OptionFootnote footnote={footnote} />
          </div>
        )
      })}
    </div>
  )
}
